<template>
  <div class="ach-box">
    <div class="ach-top ach-top-col">
      <div class="ach-item-money">业绩总额：<span class="num-color">{{ achievement.teamAllMoney }}</span> 元</div>
      <div class="ach-item-money">苹果系统业绩额：<span class="num-color-2">{{ achievement.teamIosMoney }}</span> 元</div>
      <div class="ach-item-money">安卓系统业绩额：<span class="num-color-2">{{ achievement.teamAndroidMoney }}</span> 元</div>
      <div class="ach-item-team">业务员总数：<span class="num-color">{{ achievement.teamSalesmanNum }}</span> 人</div>
      <div class="ach-item-team">用户总数：<span class="num-color">{{ achievement.teamUserNum }}</span> 人</div>
    </div>
<!--    <div class="ach-bottom ach-bottom-col">-->
<!--      <div class="ach-item-money">育成团队长总业绩额：<span class="num-color">{{ achievement.fosterAllMoney }}</span> 元</div>-->
<!--      <div class="ach-item">育成团队长人数：<span class="num-color">{{ achievement.fosterNum }}</span> 人</div>-->
<!--      <div class="ach-item">育成团队长总用户数：<span class="num-color">{{ achievement.fosterUserNum }}</span> 人</div>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'AchievementInfo',
  data () {
    return {
    }
  },
  props: {
    // 业绩信息
    'achievement': {
      type: Object,
      default: {
        fosterAllMoney: 0,
        fosterNum: 0,
        fosterUserNum: 0,
        teamAllMoney: 0,
        teamSalesmanNum: 0,
        teamUserNum: 0
      }
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style>
.ach-box {
  margin-bottom: 20px;
  border: 1px solid #dedede;
  border-radius: 5px;
}
.ach-top {
  border-bottom: 1px solid #dedede;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.ach-bottom {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.ach-item {
  width: 50%;
  text-align: center;
  padding: 30px 0 30px 0;
  font-weight: bold;
  font-size: 18px;
}
.ach-item-money {
  width: 100%;
  text-align: center;
  padding: 30px 0 0 0;
  font-weight: bold;
  font-size: 18px;
}
.num-color {
  color: #ff4d51;
}
.ach-top-col {
  color: #3a8ee6;
}
.ach-bottom-col {
  color: #67C23A;
}
</style>



// WEBPACK FOOTER //
// src/components/user/AchievementInfo.vue